import * as React from "react";
import { WaitingOrderTransactions } from "../waiting-order-transactions";

// OrderTransactionType.Trade = 3
export const TradesWaitingForAcceptReceipt = () => (
    <WaitingOrderTransactions
        orderType={3}
        pageTitle="ترید های در انتظار تایید"
        cardTitle="ترید های در انتظار"
        className="pmx-trades-waiting-for-accept-receipt"
        exportFileName="ترید های در انتظار"
    />
);
